import { isEntityType } from 'Data/payments.js'
import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClick(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })
  let entity_type_id = useDataValue({
    context: 'entity_type',
    path: 'id',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change([entity_type_id])
      return
    }

    if (current.includes(entity_type_id)) {
      let newSelected = current.filter(item => item !== entity_type_id)
      change(newSelected)
    } else {
      change([...current, entity_type_id])
    }
  }
}

export function getCount(transactions, type) {
  return transactions.filter(item => isEntityType(item, type)).length
}
